import { render, staticRenderFns } from "./docTable.vue?vue&type=template&id=75853f6c&scoped=true&"
import script from "./docTable.vue?vue&type=script&lang=js&"
export * from "./docTable.vue?vue&type=script&lang=js&"
import style0 from "./docTable.vue?vue&type=style&index=0&id=75853f6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75853f6c",
  null
  
)

export default component.exports